/**
 * @constructor
 * @param {string=} name
 * @returns {MadnesGroup}
 */
import {randomString} from "../../utils/helpers";
import {
	madnes_add_group,
	madnes_add_to_group,
	madnes_destroy_group,
	madnes_key_exist,
	madnes_remove_from_group,
	madnes_set_alpha,
	madnes_set_pos,
	madnes_set_pos_x,
	madnes_set_pos_y,
	madnes_set_scale,
	madnes_set_visible
} from "../../../framework/src/engine/madnes/madnes_object";
import {madnes_set_pivot} from "../../../framework/src/engine/madnes/madnes";
import {madnes_add_mask} from "../../../framework/src/engine/madnes/madnes_draw";

export function MadnesGroup(name) {

	if(typeof name === 'undefined') {
		name = this._generateId();
	}

	this.name = name;
};

MadnesGroup.prototype._generateId = function() {

	var key = randomString();
	while(madnes_key_exist(key)) {
		key = randomString();
	}

	return key;
};

/**
 * @returns {MadnesGroup}
 */
MadnesGroup.prototype.create = function(phaser) {
	madnes_add_group(this.name, phaser);
	return this;
};

/**
 * @param {MadnesObject} madnesObject
 * @returns {MadnesGroup}
 */
MadnesGroup.prototype.add = function(madnesObject) {
	madnes_add_to_group(this.name, madnesObject.name);
	return this;
};

/**
 * @param {MadnesObject} madnesObject
 * @returns {MadnesGroup}
 */
MadnesGroup.prototype.remove = function(madnesObject) {
	madnes_remove_from_group(this.name, madnesObject.name);
	return this;
};

/**
 * WARN: Destroying group won't remove objects from madnes_objects global! (todo fix)
 */
MadnesGroup.prototype.destroy = function() {
	madnes_destroy_group(this.name, false);
};

/**
 * @param {boolean} bool
 * @returns {MadnesGroup}
 */
MadnesGroup.prototype.setVisible = function(bool) {
	madnes_set_visible(this.name, bool);
	return this;
};

/**
 * @param {number} alpha
 * @returns {MadnesGroup}
 */
MadnesGroup.prototype.setAlpha = function(alpha) {
	madnes_set_alpha(this.name, alpha);
	return this;
};

/**
 * @param {number} x
 * @param {number} y
 * @returns {MadnesGroup}
 */
MadnesGroup.prototype.setPos = function(x, y) {
	madnes_set_pos(this.name, x, y);
	return this;
};

/**
 * @param {number} x
 * @returns {MadnesGroup}
 */
MadnesGroup.prototype.setPosX = function(x) {
	madnes_set_pos_x(this.name, x);
	return this;
};

/**
 * @param {number} y
 * @returns {MadnesGroup}
 */
MadnesGroup.prototype.setPosY = function(y) {
	madnes_set_pos_y(this.name, y);
	return this;
};

/**
 * @param {number} x
 * @param {number} y
 * @returns {MadnesGroup}
 */
MadnesGroup.prototype.setScale = function(x, y) {
	madnes_set_scale(this.name, x, y);
	return this;
};

/**
 * @param {number} x
 * @param {number} y
 * @returns {MadnesGroup}
 */
MadnesGroup.prototype.setPivot = function(x, y) {
	madnes_set_pivot(this.name, x, y);
	return this;
};

/**
 * @param {MadnesObject} mask
 */
MadnesGroup.prototype.setMask = function(mask) {
	madnes_add_mask(this.name, mask.name);
	return this;
};

/**
 * @param {MadnesGroup|String} obj
 * @returns {boolean}
 */
MadnesGroup.keyExists = function(obj) {
	return madnes_key_exist(typeof obj === "string" ? obj : obj.name);
};